export interface UserQueryDtoInterface {
  id: number;
  title: string;
  note: string;
  tagsRaw?: string;
  itemsCount: number;
  newItemsCount: number;
  updateTime: Date;
  previousUpdateTime: Date;
  visitTime: Date;
  notification: boolean;
  searchQuery: {};

}

export class UserQueryDto implements UserQueryDtoInterface{

  constructor(public id: number,
              public title: string,
              public note: string,
              public itemsCount: number,
              public newItemsCount: number,
              public updateTime: Date,
              public previousUpdateTime: Date,
              public visitTime: Date,
              public notification: boolean,
              public searchQuery: any = {}) {
  }

  public static create(){
    return new UserQueryDto(0,
      '',
      '',
      0,
      0,
      undefined,
      undefined,
      undefined,
      false);
  }

}
